import request from '@/modules/base/util/request'
import ErrorCodes from '@/enums/error-codes.enum'
import lang from '@/lang'
import accountConfig from '@/modules/account/config'
import { toast } from '@/modules/base/components/toast/toastConfig'
import { BillingAddress } from '../receipt/types'

class TenantService {
  async createTenant(isDemo: boolean): Promise<string> {
    try {
      const response = await request(accountConfig.endpoints.postNewTenant, { auth: true, method: 'POST', data: { createDemoTenant: isDemo } })
      toast.showToast({ type: 'info', message: lang.tenant.tenantCreated })
      return response.body.data?.tenant
    } catch (error) {
      const message = error.body?.message
      const tenantError = error.body?.meta?.tenant
      if (message) {
        if (tenantError) {
          if (tenantError[0].code === ErrorCodes.EXISTS) {
            toast.showToast({ type: 'error', message: lang.tenant.tenantTypeExists })
          } else {
            toast.showToast({ type: 'error', message })
          }
        } else {
          toast.showToast({ type: 'error', message })
        }
      } else {
        toast.showToast({ type: 'error', message: lang.defaultErrorMessage })
      }

      throw error
    }
  }
}

export default new TenantService()
